export const apiUrl = process.env.REACT_APP_API_URL;
export const apiAdminUrl = `${apiUrl}/admin`;
export const analyticsUrl = 'https://analytics.preghello.com';
export const master_key = process.env.REACT_APP_MASTER_KEY || 'G7LTL9FkkwFBOl7fSEjYQ5emxGcaNUY1';
